import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from "@mui/material";
import Form from "components/Form";
import TextField from "components/TextField";

function FeedbackModal({
  isOpen,
  onClose,
  onSubmit
}: {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (comentario: string) => void;
}) {

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
    >
      <DialogTitle>Feedback</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Essa resposta foi útil? Nos conte como podemos melhorar.
        </DialogContentText>
        <Form onSubmit={({ comentario }: { comentario: string }) => onSubmit(comentario)} id="subscription-form">
          <TextField
            id="comentario"
            name="comentario"
            label="Comentário"
            fullWidth
            multiline
            rows={3}
            sx={{ mt: 1 }}
          />
        </Form>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button type="submit" form="subscription-form">
          Enviar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default FeedbackModal;